import { CssBaseline, ThemeProvider } from '@mui/material';
import { RouterProvider } from 'react-router-dom';
import theme from './Components/Themes/Theme';
import { UserProvider } from './Constant/UserProfileContext/UserProfileProvider';
import router from './Router/Router';
import './Utils/Axios';

function App() {
  return (
    <UserProvider>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <RouterProvider router={router} />
      </ThemeProvider>
    </UserProvider>
  );
}

export default App;
